module.exports = __webpack_public_path__ + "img/theventures_logo.5613f161.png";